import type { GameCard } from "../types";

// Generated by scripts/import_cards.py from private/Intimacy Card Game.xlsx.
// Do not edit by hand.
export const CARD_SOURCE = {
  "workbook": "private/Intimacy Card Game.xlsx",
  "sheets": [
    "Talks",
    "Foreplay by Suami",
    "Foreplay by Istri",
    "Penetrasi Normal",
    "Penetrasi Hard",
    "Penetrasi Extreme"
  ],
  "totalCards": 111,
  "talksCards": 50,
  "foreplayHusbandCards": 20,
  "foreplayWifeCards": 20,
  "penetrationCards": 21
} as const;

export const cards = [
  {
    "id": "IC-TALK-SUAMI-01",
    "deck": "talks",
    "actor": "husband",
    "sequence": 1,
    "randomizable": true,
    "text": "Bagian tubuh mana dari aku yang paling kamu rindukan untuk disentuh malam ini?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-02",
    "deck": "talks",
    "actor": "husband",
    "sequence": 2,
    "randomizable": true,
    "text": "Sentuhan seperti apa yang paling bikin kamu meleleh dan bergairah?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-03",
    "deck": "talks",
    "actor": "husband",
    "sequence": 3,
    "randomizable": true,
    "text": "Kalau aku mencium leher dan telingamu pelan-pelan, kamu lebih suka yang lembut atau agak kuat?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-04",
    "deck": "talks",
    "actor": "husband",
    "sequence": 4,
    "randomizable": true,
    "text": "Apa rasanya saat aku mulai mengelusmu?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-05",
    "deck": "talks",
    "actor": "husband",
    "sequence": 5,
    "randomizable": true,
    "text": "Kamu lebih suka foreplay yang lama dan pelan, atau ada momen yang langsung intens?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-06",
    "deck": "talks",
    "actor": "husband",
    "sequence": 6,
    "randomizable": true,
    "text": "Bagian mana dari tubuhmu yang paling sensitif dan ingin disentuh malam ini?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-07",
    "deck": "talks",
    "actor": "husband",
    "sequence": 7,
    "randomizable": true,
    "text": "Kalau aku boleh memanjakanmu dengan tangan dan jari-jari, kamu mau di bagian mana dulu?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-08",
    "deck": "talks",
    "actor": "husband",
    "sequence": 8,
    "randomizable": true,
    "text": "Apa kata-kata atau pujian yang paling bikin kamu merasa seksi dan diinginkan?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-09",
    "deck": "talks",
    "actor": "husband",
    "sequence": 9,
    "randomizable": true,
    "text": "Kamu lebih suka kita berhubungan dengan lampu menyala atau dalam keadaan agak gelap?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-10",
    "deck": "talks",
    "actor": "husband",
    "sequence": 10,
    "randomizable": true,
    "text": "Fantasi kecil apa yang pernah kamu bayangkan tentang kita berdua di momen intim?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-11",
    "deck": "talks",
    "actor": "husband",
    "sequence": 11,
    "randomizable": true,
    "text": "Kamu paling suka aku pakai baju apa saat mau berhubungan?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-12",
    "deck": "talks",
    "actor": "husband",
    "sequence": 12,
    "randomizable": true,
    "text": "Lebih suka dimainin payudaramu pakai tangan atau pakai mulut dan lidah?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-13",
    "deck": "talks",
    "actor": "husband",
    "sequence": 13,
    "randomizable": true,
    "text": "Kamu lebih suka aku gerak pelan dan dalam, atau cepat dan kuat?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-14",
    "deck": "talks",
    "actor": "husband",
    "sequence": 14,
    "randomizable": true,
    "text": "Posisi mana yang paling kamu nikmati karena bisa saling pandang mata?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-15",
    "deck": "talks",
    "actor": "husband",
    "sequence": 15,
    "randomizable": true,
    "text": "Kamu lebih suka foreplay dilakukan di kasur, sofa, atau tempat lain di rumah?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-16",
    "deck": "talks",
    "actor": "husband",
    "sequence": 16,
    "randomizable": true,
    "text": "Apa yang paling bikin kamu basah dan bergairah saat aku menggoda kamu?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-17",
    "deck": "talks",
    "actor": "husband",
    "sequence": 17,
    "randomizable": true,
    "text": "Mau aku rangsang vaginamu pelan-pelan dengan jari atau langsung intens?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-18",
    "deck": "talks",
    "actor": "husband",
    "sequence": 18,
    "randomizable": true,
    "text": "Kata-kata apa yang paling kamu suka aku katakan saat kita sedang berhubungan",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-19",
    "deck": "talks",
    "actor": "husband",
    "sequence": 19,
    "randomizable": true,
    "text": "Kamu suka kalau aku tarik rambutmu pelan sambil dari belakang?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-20",
    "deck": "talks",
    "actor": "husband",
    "sequence": 20,
    "randomizable": true,
    "text": "Mau kita coba sesuatu yang baru malam ini, atau tetap dengan yang biasa kamu suka?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-21",
    "deck": "talks",
    "actor": "husband",
    "sequence": 21,
    "randomizable": true,
    "text": "Posisi apa yang paling kamu suka?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-22",
    "deck": "talks",
    "actor": "husband",
    "sequence": 22,
    "randomizable": true,
    "text": "Apa yang paling membuat kamu keenakan saat aku berada di dalam kamu?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-23",
    "deck": "talks",
    "actor": "husband",
    "sequence": 23,
    "randomizable": true,
    "text": "Lebih suka dimasukkan pakai tangan atau pakai penis?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-24",
    "deck": "talks",
    "actor": "husband",
    "sequence": 24,
    "randomizable": true,
    "text": "Apa yang paling kamu inginkan aku lakukan sekarang agar kamu sangat keenakan?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-SUAMI-25",
    "deck": "talks",
    "actor": "husband",
    "sequence": 25,
    "randomizable": true,
    "text": "Setelah kita selesai, mau aku peluk kamu sambil kita saling cerita apa yang paling kamu nikmati?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-01",
    "deck": "talks",
    "actor": "wife",
    "sequence": 1,
    "randomizable": true,
    "text": "Sebenarnya apa harapan kamu soal kehidupan seksual kita?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-02",
    "deck": "talks",
    "actor": "wife",
    "sequence": 2,
    "randomizable": true,
    "text": "Pakaian seperti apa yang ingin kamu aku pakai di rumah?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-03",
    "deck": "talks",
    "actor": "wife",
    "sequence": 3,
    "randomizable": true,
    "text": "Dandanan seperti apa yang paling kamu suka saat kita berhubungan?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-04",
    "deck": "talks",
    "actor": "wife",
    "sequence": 4,
    "randomizable": true,
    "text": "Bagian tubuh mana dari aku yang paling kamu suka sentuh dan cium?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-05",
    "deck": "talks",
    "actor": "wife",
    "sequence": 5,
    "randomizable": true,
    "text": "Sentuhan seperti apa yang paling membuatmu keras?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-06",
    "deck": "talks",
    "actor": "wife",
    "sequence": 6,
    "randomizable": true,
    "text": "Kamu lebih suka aku cium dada atau turun ke bawah perlahan?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-07",
    "deck": "talks",
    "actor": "wife",
    "sequence": 7,
    "randomizable": true,
    "text": "Apa yang terjadi di tubuhmu saat aku mulai menggoda kamu?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-08",
    "deck": "talks",
    "actor": "wife",
    "sequence": 8,
    "randomizable": true,
    "text": "Kamu lebih suka foreplay yang lembut dan lama atau langsung mulai?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-09",
    "deck": "talks",
    "actor": "wife",
    "sequence": 9,
    "randomizable": true,
    "text": "Kata-kata apa yang paling bikin kamu bergairah saat aku bisikan?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-10",
    "deck": "talks",
    "actor": "wife",
    "sequence": 10,
    "randomizable": true,
    "text": "Mau aku duduk di pangkuanmu sambil menggesek pelan?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-11",
    "deck": "talks",
    "actor": "wife",
    "sequence": 11,
    "randomizable": true,
    "text": "Fantasi romantis apa yang kamu bayangkan tentang kita?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-12",
    "deck": "talks",
    "actor": "wife",
    "sequence": 12,
    "randomizable": true,
    "text": "Kamu lebih suka lampu redup atau gelap saat kita intim?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-13",
    "deck": "talks",
    "actor": "wife",
    "sequence": 13,
    "randomizable": true,
    "text": "Apa skenario berhubungan yang sedang kamu inginkan? (ceritakan dari awal persiapan)",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-14",
    "deck": "talks",
    "actor": "wife",
    "sequence": 14,
    "randomizable": true,
    "text": "Mau aku memanjakanmu dengan tangan malam ini?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-15",
    "deck": "talks",
    "actor": "wife",
    "sequence": 15,
    "randomizable": true,
    "text": "Kamu lebih suka punyamu aku mainkan dengan tangan pelan atau dengan remasan intens?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-16",
    "deck": "talks",
    "actor": "wife",
    "sequence": 16,
    "randomizable": true,
    "text": "Seberapa suka kalau aku di atas dan gerak pelan sambil menciummu?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-17",
    "deck": "talks",
    "actor": "wife",
    "sequence": 17,
    "randomizable": true,
    "text": "Mau gak aku usap dan remas punyamu pelan-pelan dengan penuh cinta?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-18",
    "deck": "talks",
    "actor": "wife",
    "sequence": 18,
    "randomizable": true,
    "text": "Apa yang paling membuat kamu mengerang saat aku melakukannya?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-19",
    "deck": "talks",
    "actor": "wife",
    "sequence": 19,
    "randomizable": true,
    "text": "Kamu lebih suka aku gerak lambat atau agak cepat?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-20",
    "deck": "talks",
    "actor": "wife",
    "sequence": 20,
    "randomizable": true,
    "text": "Kata-kata apa yang paling kamu suka aku katakan saat kita berhubungan?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-21",
    "deck": "talks",
    "actor": "wife",
    "sequence": 21,
    "randomizable": true,
    "text": "Kamu suka kalau aku naik di atas dan mengontrol ritme?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-22",
    "deck": "talks",
    "actor": "wife",
    "sequence": 22,
    "randomizable": true,
    "text": "Mau kita lakukan dengan penuh ciuman dan pelukan?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-23",
    "deck": "talks",
    "actor": "wife",
    "sequence": 23,
    "randomizable": true,
    "text": "Seberapa lama kamu ingin aku memanjakanmu dulu?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-24",
    "deck": "talks",
    "actor": "wife",
    "sequence": 24,
    "randomizable": true,
    "text": "Posisi apa yang paling kamu suka?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-TALK-ISTRI-25",
    "deck": "talks",
    "actor": "wife",
    "sequence": 25,
    "randomizable": true,
    "text": "Di mana tempat kamu ingin kita melakukan hubungan seks tapi belum kesampaian?",
    "notes": "Pastikan pasangan nyaman menjawab; boleh skip kapan saja."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-01",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 1,
    "randomizable": false,
    "text": "Peluk [nama istri] erat dari belakang, dada [nama suami] menempel punggungnya. Cium tengkuk pelan sambil bisik “Malam ini aku mau bikin kamu basah dan minta sendiri ya sayang…” sambil elus perut naik-turun sangat pelan.",
    "title": "Peluk Rahasia dari Belakang",
    "durationLabel": "60 detik",
    "durationSeconds": 60,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-02",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 2,
    "randomizable": false,
    "text": "Pijat bahu, leher, dan punggung [nama istri] dengan tekanan sedang sambil cium telinga dan bisik pujian nakal “Tubuhmu sudah merinding ya…”.",
    "title": "Pijat Panas Menggoda",
    "durationLabel": "2,5 menit",
    "durationSeconds": 150,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-03",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 3,
    "randomizable": false,
    "text": "Putar [nama istri] menghadap, cium kening, mata, pipi, hidung, lalu bibir sangat pelan dengan eye contact panjang. Pegang wajahnya lembut.",
    "title": "Ciuman Wajah Lambat",
    "durationLabel": "60 detik",
    "durationSeconds": 60,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-04",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 4,
    "randomizable": false,
    "text": "Ciuman dalam dan lambat sambil pegang wajah [nama istri], lidah bermain pelan, buat dia mendesah di mulutmu.",
    "title": "French Kiss Menggoda Dalam",
    "durationLabel": "90–120 detik",
    "durationSeconds": 120,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-05",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 5,
    "randomizable": false,
    "text": "Hisap dan jilat leher + telinga [nama istri] pelan-pelan, gigit kecil, sambil bisik “Kamu sudah basah belum ya…?”",
    "title": "Leher & Telinga Torture",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-06",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 6,
    "randomizable": false,
    "text": "Sentuh seluruh tubuh [nama istri] dengan ujung jari sangat pelan dari leher sampai paha (belum area intim), buat dia merinding hebat.",
    "title": "Sentuhan Seluruh Tubuh",
    "durationLabel": "2 menit",
    "durationSeconds": 120,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-07",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 7,
    "randomizable": false,
    "text": "Remas dan mainkan payudara [nama istri] dengan kedua tangan di atas baju, jempol putar puting pelan lalu semakin kuat sambil eye contact.",
    "title": "Payudara Tease di Atas Baju",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-08",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 8,
    "randomizable": false,
    "text": "Hisap dan mainkan puting [nama istri] dengan mulut & lidah (setelah baju dibuka pelan), gigit kecil, buat dia melengkungkan badan.",
    "title": "Puting Play Intens",
    "durationLabel": "60–90 detik per sisi",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-09",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 9,
    "randomizable": false,
    "text": "Cium dan gigit pelan bagian dalam paha [nama istri] naik-turun, semakin dekat ke vagina tapi belum menyentuh. Bisik “Mau aku sentuh di sini belum sayang?”",
    "title": "Paha Dalam Godaan",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-10",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 10,
    "randomizable": false,
    "text": "Gosok klitoris [nama istri] di atas celana dalam dengan dua jari pelan melingkar sambil cium bibirnya dalam dan bisik “Sudah sangat basah nih…”.",
    "title": "Klitoris Tease Luar",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-11",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 11,
    "randomizable": false,
    "text": "Masukkan satu jari pelan-pelan ke vagina sambil cium bibir dan pandang mata, gerakkan sangat lambat.",
    "title": "Jari Pertama Masuk",
    "durationLabel": "2 menit",
    "durationSeconds": 120,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-12",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 12,
    "randomizable": false,
    "text": "Masukkan dua jari sambil ibu jari gosok klitoris ritme pelan → sedang → pelan lagi. Bisik “Rasanya enak ya sayang? Mau lebih dalam?”",
    "title": "Double Finger + Klitoris",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-13",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 13,
    "randomizable": false,
    "text": "Pijat dan remas pantat [nama istri] kuat-kuat sambil cium leher dari belakang, angkat sedikit pinggulnya.",
    "title": "Remas Pantat Nakal",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-14",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 14,
    "randomizable": false,
    "text": "Posisi doggy ringan ([nama istri] merangkak), [nama suami] di belakang elus & cium pantat + punggung sambil gesek kepala penis di luar vagina (belum masuk).",
    "title": "Doggy Tease Sensual",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-15",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 15,
    "randomizable": false,
    "text": "[nama istri] duduk di pangkuan [nama suami], gesekkan vaginanya di batang penis [nama suami] tanpa masuk, gerak naik-turun pelan sambil ciuman tanpa henti.",
    "title": "Grinding Panas di Pangkuan",
    "durationLabel": "2 menit",
    "durationSeconds": 120,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-16",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 16,
    "randomizable": false,
    "text": "Tekan [nama istri] ke dinding (punggung menghadap), gosok klitoris dari belakang sambil remas payudara dan bisik “Mau aku masukin sekarang belum?”",
    "title": "Wall Press Godaan",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-17",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 17,
    "randomizable": false,
    "text": "Gosok klitoris + dua jari di dalam dengan ritme cepat sampai [nama istri] hampir klimaks, lalu berhenti total 10 detik. Ulangi 2 kali.",
    "title": "Edging Klitoris Pertama",
    "durationLabel": "2,5 menit",
    "durationSeconds": 150,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-18",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 18,
    "randomizable": false,
    "text": "[nama suami] duduk di tepi tempat tidur, tarik [nama istri] menghadap dan duduk di salah satu paha [nama suami]. [nama suami] pegang pinggul [nama istri] kuat-kuat lalu gerakkan pinggulnya naik-turun sehingga vaginanya bergesek keras di paha [nama suami] sambil [nama suami] remas pantat dan cium leher dalam-dalam.",
    "title": "Paha Grind Control",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-19",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 19,
    "randomizable": false,
    "text": "Gosok klitoris + dua jari di dalam dengan ritme lebih cepat lagi sampai [nama istri] hampir klimaks, lalu berhenti 15 detik. Ulangi 2 kali.",
    "title": "Edging Klitoris Kedua",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-SUAMI-20",
    "deck": "foreplay_husband",
    "actor": "husband",
    "sequence": 20,
    "randomizable": false,
    "text": "Posisi missionary ringan, gesek kepala penis di luar vagina sambil dua jari tetap di dalam + gosok klitoris. Eye contact + bisik “Bilang ‘aku mau kamu masuk sekarang’ ya sayang…” sampai [nama istri] benar-benar mendesah minta.",
    "title": "Final Tease Siap Penetrasi",
    "durationLabel": "2 menit",
    "durationSeconds": 120,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-01",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 1,
    "randomizable": false,
    "text": "Peluk [nama suami] erat dari depan, tekan payudara [nama istri] kuat-kuat ke dada [nama suami]. Cium dada pelan sambil bisik “Malam ini aku mau bikin kamu gila dengan tubuhku ya sayang…” sambil gesekkan payudara naik-turun.",
    "title": "Peluk Payudara Rahasia",
    "durationLabel": "60 detik",
    "durationSeconds": 60,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-02",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 2,
    "randomizable": false,
    "text": "Pijat bahu dan dada [nama suami] sambil terus gesekkan payudara [nama istri] ke tubuhnya, puting [nama istri] sengaja digosok-gosok ke kulit [nama suami].",
    "title": "Pijat Payudara Nakal",
    "durationLabel": "2,5 menit",
    "durationSeconds": 150,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-03",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 3,
    "randomizable": false,
    "text": "Cium kening, mata, pipi, hidung, lalu bibir [nama suami] sangat pelan sambil tangan [nama istri] sudah mulai turun ke perutnya.",
    "title": "Ciuman Wajah Menggoda",
    "durationLabel": "60 detik",
    "durationSeconds": 60,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-04",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 4,
    "randomizable": false,
    "text": "Ciuman dalam dan lambat sambil [nama istri] tekan payudara ke dada [nama suami] kuat-kuat, gerakkan tubuh [nama istri] pelan supaya [nama suami] merasakan kelembutan penuh.",
    "title": "French Kiss + Payudara Press",
    "durationLabel": "90–120 detik",
    "durationSeconds": 120,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-05",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 5,
    "randomizable": false,
    "text": "Cium, hisap, dan gigit pelan leher + telinga [nama suami] sambil terus gesekkan payudara [nama istri] ke perut dan dada [nama suami].",
    "title": "Leher Torture dengan Payudara",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-06",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 6,
    "randomizable": false,
    "text": "[nama istri] gesekkan payudara dan putingnya ke seluruh tubuh [nama suami] (dada, perut, paha) sangat pelan sambil tangan menyentuh ringan.",
    "title": "Sentuhan Payudara Seluruh Tubuh",
    "durationLabel": "2 menit",
    "durationSeconds": 120,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-07",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 7,
    "randomizable": false,
    "text": "Gesekkan puting [nama istri] ke puting [nama suami] sambil tangan [nama istri] elus paha [nama suami] semakin dekat ke penis.",
    "title": "Puting [nama suami] Tease dengan Payudara",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-08",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 8,
    "randomizable": false,
    "text": "Hisap dan mainkan puting [nama suami] dengan mulut & lidah sambil tangan [nama istri] sudah meremas paha dalam.",
    "title": "Puting Play Intens",
    "durationLabel": "60–90 detik per sisi",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-09",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 9,
    "randomizable": false,
    "text": "Cium dan gesekkan payudara [nama istri] ke bagian dalam paha [nama suami] naik-turun, semakin dekat ke penis tapi belum menyentuh.",
    "title": "Paha Dalam Godaan Payudara",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-10",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 10,
    "randomizable": false,
    "text": "Gosok penis [nama suami] di atas celana dengan telapak tangan hangat sambil bisik “Sudah sangat keras… mau aku buka belum?”.",
    "title": "Penis Tease Luar dengan Tangan",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-11",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 11,
    "randomizable": false,
    "text": "Genggam penis [nama suami] dengan satu tangan sambil tangan satunya tekan payudara [nama istri] ke batang penis (masih di luar celana).",
    "title": "Genggam Pertama + Payudara",
    "durationLabel": "2 menit",
    "durationSeconds": 120,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-12",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 12,
    "randomizable": false,
    "text": "[nama istri] berlutut di depan [nama suami], masukkan penis di antara payudara [nama istri] (masih pakai celana tipis atau sudah dibuka pelan) dan gerakkan naik-turun pelan sambil eye contact.",
    "title": "Titjob Tease Awal",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-13",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 13,
    "randomizable": false,
    "text": "Mainkan penis dengan tangan ritme pelan → sedang sambil tangan satunya mainkan bola, sesekali gesekkan payudara ke kepala penis.",
    "title": "Handjob + Bola Nakal",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-14",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 14,
    "randomizable": false,
    "text": "[nama istri] berlutut, masukkan penis sepenuhnya di antara payudara, gerakkan naik-turun sensual sambil tangan meremas sendiri payudara supaya lebih rapat. Bisik “Enak ya sayang?”.",
    "title": "Titjob Full Nakal",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-15",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 15,
    "randomizable": false,
    "text": "[nama istri] duduk di pangkuan [nama suami] (face to face), gesekkan vagina dan payudara di batang penis tanpa masuk, [nama istri] yang sepenuhnya mengontrol kecepatan dan tekanan.",
    "title": "Lap Ride Control",
    "durationLabel": "2 menit",
    "durationSeconds": 120,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-16",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 16,
    "randomizable": false,
    "text": "[nama istri] berlutut lagi, kombinasi titjob pelan + handjob cepat sampai [nama suami] hampir klimaks, lalu berhenti total 10 detik. Ulangi 2 kali.",
    "title": "Edging Payudara + Tangan",
    "durationLabel": "2,5 menit",
    "durationSeconds": 150,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-17",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 17,
    "randomizable": false,
    "text": "[nama istri] tetap di pangkuan, gerakkan pinggul lebih cepat dan kuat sambil tekan payudara ke wajah [nama suami], biarkan [nama suami] mencium puting [nama istri].",
    "title": "Intense Lap Grind",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-18",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 18,
    "randomizable": false,
    "text": "Titjob + handjob lebih intens lagi sampai [nama suami] mendesah minta, lalu berhenti 15 detik. Ulangi 2 kali.",
    "title": "Edging Titjob Kedua",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-19",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 19,
    "randomizable": false,
    "text": "[nama istri] berlutut, gesekkan penis di antara payudara dengan gerakan cepat dan kuat sambil tangan meremas bola [nama suami] lembut.",
    "title": "Body Slide Panas",
    "durationLabel": "90 detik",
    "durationSeconds": 90,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-FOREPLAY-ISTRI-20",
    "deck": "foreplay_wife",
    "actor": "wife",
    "sequence": 20,
    "randomizable": false,
    "text": "[nama istri] duduk di pangkuan [nama suami], handjob pelan sambil gesekkan kepala penis di luar vagina [nama istri] + tekan payudara ke dada [nama suami]. Eye contact + bisik “Bilang ‘aku mau masuk sekarang’ ya sayang…” sampai [nama suami] benar-benar mendesah minta.",
    "title": "Final Tease Siap Penetrasi",
    "durationLabel": "2 menit",
    "durationSeconds": 120,
    "notes": "Berhenti atau turunkan intensitas bila pasangan tidak nyaman."
  },
  {
    "id": "IC-PEN-NORMAL-01",
    "deck": "penetration",
    "actor": "both",
    "sequence": 1,
    "randomizable": true,
    "text": "[nama istri] telentang di kasur (punggung menempel kasur). Kedua kakinya terbuka lebar, lutut ditekuk, telapak kaki menapak kasur di samping pinggul [nama suami]. [nama suami] berbaring di atas [nama istri] (dada menempel dada), tangan [nama suami] bertumpu di kasur di samping kepala [nama istri]. [nama suami] memasukkan penis sepenuhnya lalu gerak maju-mundur pelan dan dalam sambil saling pandang mata.",
    "level": "normal",
    "title": "Missionary Klasik",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-NORMAL-02",
    "deck": "penetration",
    "actor": "both",
    "sequence": 2,
    "randomizable": true,
    "text": "Keduanya berbaring miring ([nama istri] di depan). Punggung [nama istri] menempel dada [nama suami]. [nama istri] tekuk lutut sedikit. [nama suami] memeluk dari belakang, satu tangan di bawah kepala [nama istri], satu tangan meremas payudara. [nama suami] memasukkan penis dari belakang lalu gerak pelan.",
    "level": "normal",
    "title": "Spooning Biasa",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-NORMAL-03",
    "deck": "penetration",
    "actor": "both",
    "sequence": 3,
    "randomizable": true,
    "text": "[nama suami] berbaring telentang. [nama istri] duduk di atas menghadap [nama suami], kedua kaki [nama istri] menekuk di samping pinggul [nama suami], telapak kaki menapak kasur. [nama istri] memasukkan penis sendiri lalu naik-turun pelan sambil [nama suami] pegang pinggangnya.",
    "level": "normal",
    "title": "Cowgirl Biasa",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-NORMAL-04",
    "deck": "penetration",
    "actor": "both",
    "sequence": 4,
    "randomizable": true,
    "text": "[nama istri] merangkak (tangan + lutut menumpu), pinggul diangkat sedang. [nama suami] berlutut di belakang, pegang pinggul [nama istri] dengan kedua tangan, memasukkan penis lalu gerak maju-mundur pelan.",
    "level": "normal",
    "title": "Doggy Klasik",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-NORMAL-05",
    "deck": "penetration",
    "actor": "both",
    "sequence": 5,
    "randomizable": true,
    "text": "[nama istri] telungkup rata (perut menempel kasur), kaki sedikit terbuka. [nama suami] naik di atas punggung [nama istri] (dada menempel punggung), tangan bertumpu di kasur di samping tubuh [nama istri]. [nama suami] memasukkan penis dari belakang lalu gerak pelan.",
    "level": "normal",
    "title": "Prone Bone Biasa",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-NORMAL-06",
    "deck": "penetration",
    "actor": "both",
    "sequence": 6,
    "randomizable": true,
    "text": "[nama suami] duduk tegak di tepi tempat tidur. [nama istri] duduk di pangkuan [nama suami] menghadap, kedua kaki [nama istri] melingkar di pinggang [nama suami]. [nama istri] memasukkan penis lalu naik-turun pelan sambil peluk [nama suami] erat.",
    "level": "normal",
    "title": "Lap Ride Pangkuan",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-NORMAL-07",
    "deck": "penetration",
    "actor": "both",
    "sequence": 7,
    "randomizable": true,
    "text": "[nama suami] berbaring telentang. [nama istri] duduk di atas membelakangi [nama suami], kedua kaki menekuk di samping pinggul [nama suami]. [nama istri] memasukkan penis lalu naik-turun pelan sambil [nama suami] pegang pinggul.",
    "level": "normal",
    "title": "Reverse Cowgirl Biasa",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-HARD-01",
    "deck": "penetration",
    "actor": "both",
    "sequence": 1,
    "randomizable": true,
    "text": "[nama istri] telentang. Kedua kakinya diangkat tinggi lalu diletakkan di bahu [nama suami] (lutut [nama istri] dekat telinga [nama suami]). [nama suami] berlutut di atas, tangan bertumpu di kasur di samping tubuh [nama istri]. [nama suami] memasukkan penis sangat dalam lalu thrusting kuat.",
    "level": "hard",
    "title": "Missionary Legs Up",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-HARD-02",
    "deck": "penetration",
    "actor": "both",
    "sequence": 2,
    "randomizable": true,
    "text": "[nama istri] merangkak, punggung melengkung tinggi, pinggul diangkat maksimal. [nama suami] berlutut di belakang, pegang pinggul kuat-kuat, memasukkan penis lalu thrusting cepat dan dalam.",
    "level": "hard",
    "title": "Doggy Arch",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-HARD-03",
    "deck": "penetration",
    "actor": "both",
    "sequence": 3,
    "randomizable": true,
    "text": "[nama suami] berbaring telentang. [nama istri] duduk di atas menghadap, kaki menekuk di samping pinggul [nama suami]. [nama suami] pegang pinggul [nama istri] kuat-kuat lalu mengatur naik-turun cepat.",
    "level": "hard",
    "title": "Cowgirl Speed",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-HARD-04",
    "deck": "penetration",
    "actor": "both",
    "sequence": 4,
    "randomizable": true,
    "text": "[nama istri] berdiri menghadap dinding, tangan menempel dinding di atas kepala. [nama suami] berdiri di belakang, angkat satu kaki [nama istri] ke atas, memasukkan penis dari belakang lalu thrusting kuat sambil pegang pinggul.",
    "level": "hard",
    "title": "Wall Press",
    "durationLabel": "2,5 menit",
    "durationSeconds": 150,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-HARD-05",
    "deck": "penetration",
    "actor": "both",
    "sequence": 5,
    "randomizable": true,
    "text": "[nama suami] berbaring telentang. [nama istri] jongkok di atas (face to face), telapak kaki menapak kasur di samping pinggul [nama suami], lutut tinggi. [nama istri] naik-turun full depth cepat.",
    "level": "hard",
    "title": "Deep Squat Ride",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-HARD-06",
    "deck": "penetration",
    "actor": "both",
    "sequence": 6,
    "randomizable": true,
    "text": "[nama istri] berbaring miring (misalnya ke kiri). Kaki bawah lurus rileks. Kaki atas ditekuk ke dada. [nama suami] berlutut di samping, melangkahi kaki bawah [nama istri], memasukkan penis dari samping. [nama suami] pegang kaki atas dan tarik ke dada [nama istri], thrusting kuat.",
    "level": "hard",
    "title": "Pretzel Twist",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-HARD-07",
    "deck": "penetration",
    "actor": "both",
    "sequence": 7,
    "randomizable": true,
    "text": "[nama istri] merangkak (tangan menumpu). [nama suami] berdiri di belakang, angkat kedua kaki [nama istri] setinggi pinggang. [nama suami] memasukkan penis lalu thrusting kuat.",
    "level": "hard",
    "title": "Wheelbarrow Light",
    "durationLabel": "3 menit",
    "durationSeconds": 180,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-EXTREME-01",
    "deck": "penetration",
    "actor": "both",
    "sequence": 1,
    "randomizable": true,
    "text": "[nama suami] duduk tegak bersila di tengah kasur. [nama istri] duduk di pangkuan menghadap, kedua kaki melingkar erat di pinggang [nama suami], telapak kaki menekan punggung [nama suami]. [nama istri] naik-turun sampai hampir klimaks lalu berhenti 10 detik. Ulangi 4 kali.",
    "level": "extreme",
    "title": "Lotus Edging",
    "durationLabel": "4 menit",
    "durationSeconds": 240,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-EXTREME-02",
    "deck": "penetration",
    "actor": "both",
    "sequence": 2,
    "randomizable": true,
    "text": "[nama suami] berbaring telentang, kaki ditekuk ke dada (seperti tabletop). [nama istri] squat di atas menghadap kaki [nama suami], kedua kaki [nama istri] lurus ke depan di samping tubuh [nama suami]. [nama istri] naik-turun sangat cepat dan dalam.",
    "level": "extreme",
    "title": "Amazon Position",
    "durationLabel": "3,5 menit",
    "durationSeconds": 210,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-EXTREME-03",
    "deck": "penetration",
    "actor": "both",
    "sequence": 3,
    "randomizable": true,
    "text": "Keduanya duduk saling berhadapan di kasur. Kaki saling silang dan kunci erat (kaki kanan [nama suami] di atas kaki kiri [nama istri], kaki kiri [nama suami] di bawah kaki kanan [nama istri]). Penis masuk dalam. [nama suami] thrusting sambil [nama istri] gerakkan pinggul.",
    "level": "extreme",
    "title": "Seated Scissor Lock",
    "durationLabel": "4 menit",
    "durationSeconds": 240,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-EXTREME-04",
    "deck": "penetration",
    "actor": "both",
    "sequence": 4,
    "randomizable": true,
    "text": "[nama suami] berdiri tegak, angkat [nama istri] (kedua kaki [nama istri] melingkar di pinggang [nama suami], tangan [nama istri] melingkar di leher [nama suami]). Punggung [nama istri] ditekan ke dinding. [nama suami] thrusting cepat sambil pegang pantat.",
    "level": "extreme",
    "title": "Wall Carry Full",
    "durationLabel": "3,5 menit",
    "durationSeconds": 210,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-EXTREME-05",
    "deck": "penetration",
    "actor": "both",
    "sequence": 5,
    "randomizable": true,
    "text": "[nama istri] merangkak (tangan menumpu). [nama suami] berdiri di belakang, angkat kedua kaki [nama istri] tinggi sampai hampir vertikal. [nama suami] memasukkan penis sangat dalam lalu thrusting intens.",
    "level": "extreme",
    "title": "Wheelbarrow Deep",
    "durationLabel": "3,5 menit",
    "durationSeconds": 210,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-EXTREME-06",
    "deck": "penetration",
    "actor": "both",
    "sequence": 6,
    "randomizable": true,
    "text": "[nama istri] berbaring miring. Kaki bawah lurus rileks. Kaki atas ditekuk sangat dekat ke dada (lutut hampir ke bahu). [nama suami] berlutut di samping, melangkahi kaki bawah, memasukkan penis dari samping. [nama suami] pegang kaki atas dan tarik ke dada, thrusting sangat dalam.",
    "level": "extreme",
    "title": "Pretzel Passion Extreme",
    "durationLabel": "4 menit",
    "durationSeconds": 240,
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  },
  {
    "id": "IC-PEN-EXTREME-07",
    "deck": "penetration",
    "actor": "both",
    "sequence": 7,
    "randomizable": true,
    "text": "[nama suami] duduk tegak bersila. [nama istri] duduk di pangkuan menghadap, kedua kaki melingkar erat di pinggang [nama suami] dan kunci kuat di belakang. Penis masuk paling dalam. Saling pandang mata dan bisik “aku cinta kamu” berulang-ulang sampai klimaks.",
    "level": "extreme",
    "title": "Finale Lotus Lock",
    "durationLabel": "durasi sampai selesai",
    "notes": "Pilih posisi yang sama-sama nyaman. Boleh skip kapan saja."
  }
] satisfies GameCard[];
